import PropTypes from 'prop-types';
// material
import { Box, Modal, Typography, Button } from '@mui/material';
// ------------------------------------------------------------------------------------------------

LogOutModalPopup.propTypes = {
    handlelogout: PropTypes.func,
    handleCloseLogOutPopup: PropTypes.func,
};
// ------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    bgcolor: 'background.paper',
    p: 3,
    borderRadius: 1.5,
    width: 360,
    height: 200,
}

const buttonStyle = {
    backgroundColor: 'common.white',
    color: 'common.black',
    border: '1.5px solid',
    borderColor: 'grey.300',
    mx: 1,
    ':hover': {
        backgroundColor: 'common.white',
        boxShadow: 10,
    }
}
// ------------------------------------------------------------------------------------------------

export default function LogOutModalPopup({ handlelogout, handleCloseLogOutPopup }) {

    return (
        <div>
            <Modal open >
                <Box sx={style}>
                    <Typography variant='h6'>
                        Logout
                    </Typography>

                    <Typography variant='subtitle1' sx={{ mt: 3, textAlign: 'center' }}>
                        Are you sure?
                    </Typography>

                    <Box sx={{ position: 'absolute', bottom: 16, right: 16 }} >
                        <Button variant="contained" onClick={handleCloseLogOutPopup} sx={buttonStyle}> No  </Button>

                        <Button type="submit" variant="contained" onClick={handlelogout} > Yes </Button>
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}